module.exports = __webpack_public_path__ + "img/chat-inbound.88d940bf.svg";